export default {"src":"/_next/static/media/wave-upper.8338dd01.svg","height":363,"width":1440,"blurWidth":0,"blurHeight":0};